@if (aufgabe | async; as _aufgabe) {
	<schir-int-client-adressaten-in-aufgabe [aufgabe]="_aufgabe"
	                                        data-test-id="adressaten-in-aufgabe" class="x-section__container"
	                                        data-help-anchor="_spalte_adressaten"/>
}
